import React from 'react';
import { useParams } from 'react-router-dom';
import SmartDocChat from './SmartDocChat';
import DocumentPreview from '@/components/document-viewer/DocumentPreview';
import { Card, CardContent } from "@/components/ui/card";

const SmartDocument: React.FC = () => {
  const { documentId } = useParams<{ documentId: string }>();

  if (!documentId) {
    return (
      <Card>
        <CardContent className="flex items-center justify-center h-32">
          <p className="text-gray-500">No document ID provided.</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <DocumentPreview
              documentId={documentId}
              contentType="application/pdf"
              className="w-full h-full"
            />
          </div>

          {/* Chat Interface */}
          <div>
            <SmartDocChat
              documentId={documentId}
              onError={(error) => {
                console.error('Chat error:', error);
                // Handle error if needed
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartDocument;